import { ACTIONS } from './constants';

const features = (state = {}, action = {}) => {
    switch (action.type) {
        case ACTIONS.FEATURES_SET:
            return {
                ...action.features
            };
        case ACTIONS.RESET_ALL:
            return {};
        default:
            return state;
    }
};

export default features;



// WEBPACK FOOTER //
// ./src/v5/features/state/featuresReducer.js